import { Component, Input, OnInit, OnChanges, SimpleChanges, HostListener, ElementRef, ViewChild,ChangeDetectorRef,ComponentFactoryResolver,ViewContainerRef, } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { SideBarJobcardService } from './side-bar-jobcard.service';
import { ActivatedRoute, NavigationStart, Router } from '@angular/router';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { S3ImageUploadService } from 'app/shared/s3-image-upload.service';
import { HttpClient } from '@angular/common/http';
import { AspHomeService } from '../../auto-spare-parts/asp-home/asp-home.service';
import { AspLoadingComponent } from '../asp-loading/asp-loading.component';
import { AspVehicleServiceHistoryComponent } from '../asp-vehicle-service-history/asp-vehicle-service-history.component';
import { AspSparesListService } from '../asp-spares-list/asp-spares-list.service';
import { AnimationOptions } from 'ngx-lottie';
import { ThrowStmt } from '@angular/compiler';
import { AspLoadingService } from '../asp-loading/asp-loading.service'; 

@Component({
  selector: 'app-side-bar-jobcard',
  templateUrl: './side-bar-jobcard.component.html',
  styleUrls: ['./side-bar-jobcard.component.scss'],
})
export class SideBarJobcardComponent implements OnInit, OnChanges {
  @ViewChild('drawingCanvas', { static: false }) drawingCanvas!: ElementRef<HTMLCanvasElement>;
  @ViewChild('carImageContainer', { static: false }) carImageContainer!: ElementRef;
  canvasContext!: CanvasRenderingContext2D | null;
  @ViewChild('fileInput', { static: false }) fileInput!: ElementRef<HTMLInputElement>;
  @ViewChild('imageElement', { static: false }) imageElement!: ElementRef<HTMLImageElement>;
  @ViewChild('frontFileInput') frontFileInput!: ElementRef<HTMLInputElement>;
  @ViewChild('engineFileInput') engineFileInput!: ElementRef<HTMLInputElement>;
  @ViewChild('batteryFileInput') batteryFileInput!: ElementRef<HTMLInputElement>;
  @ViewChild('rightFileInput') rightFileInput!: ElementRef<HTMLInputElement>;
  @ViewChild('backFileInput') backFileInput!: ElementRef<HTMLInputElement>;
  @ViewChild('leftFileInput') leftFileInput!: ElementRef<HTMLInputElement>;
  @ViewChild('addFileInput') addFileInput!: ElementRef<HTMLInputElement>;
  @ViewChild('dynamicContainers', { read: ViewContainerRef }) containers!: ViewContainerRef;
  @ViewChild('scrollContainer') scrollContainer: ElementRef;
  @ViewChild('vehicleServiceHistoryContainer', { read: ViewContainerRef }) historyContainer!: ViewContainerRef;
  @ViewChild('nextButton', { static: false }) nextButton!: ElementRef;
  @ViewChild('fuelFileInput') fuelFileInput!: ElementRef<HTMLInputElement>
  @ViewChild('meterFileInput') meterFileInput!: ElementRef<HTMLInputElement>;
  @ViewChild('accessoryFileInput') accessoryFileInput!: ElementRef<HTMLInputElement>;


  private originalBottom: string = '0px';





  otherImages: Array<{ image: string; key: string }> = [];
  otherTag: string = '';
  otherImageFile: File | null = null;
  isDrawing = false;
  selectedColor = 'blue';
  carDetailsForm: FormGroup;
  isBottomSheetOpen: boolean = false;
  imageTag: string = ''; 
  canvasWidth = 1000; 
  canvasHeight = 600; 
  selectedTab = 'Front'; 
  selectedMake: string;
  selectedModel: string;
  selectedYear: string;
  vehicleData: any = [];
  selectedVariant: string;
  errorMessage: string = '';
  filteredIssues = [];
  searchText = ''; 
  searchTextStates = ''; 
  vehicleInfo: boolean = false;
  selectedFile: File | null = null;
  vehicleForm1: FormGroup;
  formSubmitted = false;
  loading: boolean = false;
  submitted = false;
  jobCardDetails = true;
  isManualSelection: boolean = false;
  customerDetailsANDcarDetails: boolean = false;
  isVisible = false;
  isConfirmationSidebarOpen = false;
  jobCard: any = {}; // Store car details here
  // @Input() bookingId: number | null = null;
  @Input() bookingId!: string;
  @Input() name: string | null = null;
  @Input() phoneNumber: string | null = null;
  fuelAccessoriesContainer: boolean = false;
  selectedFilePreview: string | ArrayBuffer | null = null;
  accessories: any[] = [];
  carDetailsandcustomerDetails: boolean = true;
  issuesSection: boolean = false;
  imageSection: boolean = false;
  exteriorSection: boolean = false;
  selectedServices: string[] = [];
  isDropdownOpen = false;
  serviceList: string[] = [];
  isSearchOpen = false;
  selectedSection: string = '';
  fuelMeterImage: any = null;
fuelMeterImagePreview: string[] = [];
accessoriesImages: any = null;
accessoriesImagesPreview: string[] = [];
  damagedImagesData: { [key: string]: string | null } = {
    Front: null,
    Top: null,
    Right: null,
    Left: null,
    Rear: null
  };
  documentData: { name: string; type: string; fileURL: string | null } = {
    name: '',
    type: '',
    fileURL: null,
  };
  
  isImageSaved: boolean = false;
  selectedIssues: string[] = [];
  uploadedImages: string[] = [];
  frontImage: string | null = null;
  engineImage: string | null = null;
  batteryImage: string | null = null;
  rightImage: string | null = null;
  backImage: string | null = null;
  leftImage: string | null = null;
  fuelLevelImage: string | null = null;
  addImage: string | null = null;
  searchQuery = '';
  engineNumberForm: FormGroup;

  isViewerOpen: boolean = false;
  isAccessoriesViewerOpen: boolean = false;
  currentIndex = 0;
  currentTag: string = '';
  selectedImage: string = '';
  stateSliderOpen = false;
  selectedState: string = '';
  stateData: any[] = [];
  filteredStates: any[] = [];


  // Other properties
  garageKey: any;
  customerName: string;
  registrationNumber: string;
  variantKeyValue: any;
  currentUserId: any;
  rowKeyValue: any;
  isJobCardCreatedPopupVisible: boolean = false;
  successIcon: string = '../../../../assets/icons/icons8-ok.gif';
  date: any;
  jobCardId: any;
  isMobile: boolean;
  isSidebarOpen: boolean = true;
  isSideSliderOpen: boolean = false;
  drawingHistory: any[] = [];
  currentPath: { x: number, y: number }[] = [];
  selectedImages: { [key: string]: string } = {};

  car =  {
    regNumber: '',
    vin: localStorage.getItem('vin') || '',
    engineNumber: '',
    odometerReading: '',
    lastServiceDate: '',
    selectedServices: [] as string[],
  }
  customer = {
    name: '',
    mobile: '',
    email: '',
    rateCardApplicable: '',
     ratecardType: '',
  }

  fuelAndAccessories: {
    fuelLevel: number;
    checkedItems: string[];
  } = {
    fuelLevel: 0, // Default fuel level
    checkedItems: [] // Initially no items selected
  };

  issuesData: any[] = [];
  data: any;
  newlyUploadedImages: any;
  uploadedDocuments: any;
  uploadedimage: any;
  SideBarJobcardService: any;
  selectedFileName: string;
  FinalJobcardDetails: any;
  regNo: string;
  carandcustomerDetails: any;
  isImageModified: boolean;
  showServiceHistory: boolean;
  customerTag: any;
  isExistingCustomer: any;
  getBookingId: any;
  Messages: string[] = []; // Change from boolean to an array
  isSearchSidebarOpen = false;
  gstDetails = false;     // Hide GST slider by default
  hasGst: boolean = true;
  gstNumber: string = "";
  showGstSecondSlider: boolean = false;
  showBusinessInfoSlider: boolean = false;
ññññinessName: string = '';
showAddressSlider: boolean = false;
addressLine1: string = '';
addressLine2: string = '';
pincode: string = '';
city: string = '';
ratecardTypes: string[] = [];
selectedRatecardType: string = ''; 


  
  // imageElement: any;
  // fileInput: any;
  options: AnimationOptions = {
    path: './assets/images/loader.json' // Replace with your JSON animation file URL
  };
  newImages: any[] = [];
  tagsValue: any;
  meterImageUrl: any;
  customerGstForm: FormGroup;
  addressForm: FormGroup;
  gstNumberform: FormGroup;
  buisnessname: any;
  state: any;
   GstDetails: {
  gstNumber: string;
  address: string;
  state: string;
  companyName: string;
  addressLine1: string;
  addressLine2: string;
  city: string;
  pincode: string;
  
}
  prefilledData: { customerName: any; mobile: any; email: any; hasGst: boolean; gstNumber: any; registrationNumber: any; vinNumber: any; make: any; model: any; variant: any; fuelType: any; year: any; odometer: any; engineNumber: any; lastServiceDate: any; gstDetails?: any;rateCardApplicable?: any; };
  
  activeUrl: string;
  isCustomerDetails: boolean;
  errorMessage1: string;
  errorMessage2: string;
  errorMessage3: string;
  errorMessage5: string;
  errorMessage4: string;

  constructor(
    private fb: FormBuilder,
    private _formBuilder: FormBuilder,
    private sideBarJobcardService: SideBarJobcardService,
    private elementRef: ElementRef,
    private router: Router,
    private route: ActivatedRoute,
    private breakpointObserver: BreakpointObserver,
    private s3ImageUploadService: S3ImageUploadService,
    private http: HttpClient,
    public toastr: ToastrService,
    private homeService: AspHomeService,
    private cdr: ChangeDetectorRef,
    private resolver: ComponentFactoryResolver,
    private aspSparesListService: AspSparesListService,
    private aspLoadingService: AspLoadingService,
  ) {
      this.breakpointObserver.observe([Breakpoints.Handset])
    .subscribe(result => { 
      console.log("sidebarjobcard-response",result);
      this.isMobile = result.matches;
    });

    
    this.carDetailsForm = this._formBuilder.group({
      odometerReading: [
        '',
        [Validators.required, Validators.pattern(/^-?(0|[1-9]\d*)?$/)],
      ],
      selectedServices: ['', Validators.required],
      customerName: [
        '',
        [Validators.required, Validators.pattern(/^[a-zA-Z ]+$/)],
      ],
      customerMobile: [
        '',
        [
          Validators.required,
          Validators.pattern(/^-?(0|[1-9]\d*)?$/),
          Validators.minLength(10),
          Validators.maxLength(10),
        ],
      ],
      rateCardApplicable: ['', Validators.required] 

    });
    this.customerGstForm = this._formBuilder.group({
      businessName: [this.buisnessname || '', [Validators.required, Validators.minLength(2)]],
      gstNumber: [this.gstNumber, [Validators.required, Validators.pattern(/^[0-9A-Z]{15}$/)]],
      address: ['', [Validators.required, Validators.minLength(2)]],
      state: ['', Validators.required],
    });


//     this.customerGstForm = this._formBuilder.group({
//       "businessName":[this.buisnessname || '', [Validators.required, Validators.minLength(2)]],
//       "gstNumber": [this.gstNumber,Validators.required,Validators.pattern(/^[0-9A-Z]{15}$/)]
//     ,
//       "address" : ['', [Validators.required, Validators.minLength(2)]], 
//     "state": [this.selectedState, Validators.required],
//     
//   });



  this.addressForm = this._formBuilder.group({
    addressLine1: [this.addressLine1 || ''],
    addressLine2: [this.addressLine2 || ''],
    pincode: [this.pincode || ''],
    city: [this.city || '']
  });
  
  
  
  }
onImageLoad() {
  // Delay is optional but helps if rendering still lags
  setTimeout(() => {
    this.enableDrawing();
  }, 100); // Small delay to ensure layout is done
}

  get engineNumber() {
    return this.engineNumberForm.get('engineNumber');
  }
  get cgf() {
    return this.customerGstForm.controls;
  }
  get gst(){
    return this.gstNumberform.controls;
  }
  get af() {
    return this.addressForm.controls;
  }

  ngOnInit(): void { 
    if(localStorage.getItem('jobcard') && localStorage.getItem('jobcard') === '1' ){
      this.isManualSelection = true;
      
    }
    
    // Initialize form with phoneNumber and name from Input properties
    this.vehicleForm1 = this._formBuilder.group({
       regNo: [this.regNo ||'', [Validators.required,Validators.minLength(13), Validators.maxLength(13)]],
      // odometer: ['', [Validators.required]],
      rowKey: [''],
      variantKey: [''],
      // phoneNumber: [this.phoneNumber || '', [Validators.required, Validators.minLength(10)]],
      // name: [this.name || '', Validators.required]
    });
    // Initialize vehicleForm1 instead of vehicleForm
    this.vehicleForm1.get('regNo')?.valueChanges.subscribe(value => {
      if (value) {
        // this.vehicleForm.get('regNo')?.setValue(value.toUpperCase(), { emitEvent: false });
        const formattedValue = this.formatRegNo(value);
        this.vehicleForm1.get('regNo')?.setValue(formattedValue, { emitEvent: false });
      }
    });
    this.vehicleData = JSON.parse(localStorage.getItem("vehicleData"));
    if(this.vehicleData){
      this.vehicleInfo = true;
    }else{
      this.vehicleInfo = false;
    }
    this.router.events.subscribe((event: any) => {
      if (event instanceof NavigationStart) {
        // Detect if it's a reload
        if (event.navigationTrigger === 'popstate') {
          // Clear localStorage if the page was reloaded
          this.clearLocalStorage();
        }
      }
      this.addressForm = this._formBuilder.group({
        addressLine1: [''],
        addressLine2: [''],
        pincode: [''],
        city: ['']
      });
    });


    if (!this.bookingId ){
      // Fetch details from localStorage
      this.selectedMake = localStorage.getItem('selectedMake') || '';
      this.selectedModel = localStorage.getItem('selectedModel') || '';
      this.selectedVariant = localStorage.getItem('variant') || '';
      this.selectedYear = localStorage.getItem('selectedYear') || '';

      this.jobCard = {
        make: this.selectedMake,
        model: this.selectedModel,
        variant: this.selectedVariant,
        mfgYear: this.selectedYear,
        fuelType: localStorage.getItem('fuelType') || '',
        vin: localStorage.getItem('vin') || ''
      };

      // Automatically populate the form
      this.vehicleForm1.patchValue({
        make: this.selectedMake,
        model: this.selectedModel,
        variant: this.selectedVariant,
        year: this.selectedYear
      });
      
    }
    this.fetchStates();
 if (this.prefilledData) {
  this.vehicleForm1.patchValue({
    regNo: this.prefilledData.registrationNumber || '',
    make: this.prefilledData.make || '',
    model: this.prefilledData.model || '',
    variant: this.prefilledData.variant || '',
    year: this.prefilledData.year || '',
    fuelType: this.prefilledData.fuelType || '',
    vin: this.prefilledData.vinNumber || '',
    engineNumber: this.prefilledData.engineNumber || '',
    odometer: this.prefilledData.odometer || '',
    lastServiceDate: this.prefilledData.lastServiceDate || '',
    gstNumber: this.prefilledData.gstNumber || '',
    rateCardApplicable: this.prefilledData.rateCardApplicable || ''
  });
  console.log("this.prefilledData-----",this.prefilledData);

  this.hasGst = !!this.prefilledData.hasGst && this.prefilledData.hasGst === true;

  // Set gstDetails to false if GST number is present
  if (this.prefilledData.gstNumber && this.prefilledData.gstNumber.trim() !== '') {
    // this.isVisible = true;
    // this.isConfirmationSidebarOpen = true;
    // this.customerDetailsANDcarDetails = true;
    // this.showGstSecondSlider = true;
    this.gstDetails = false;
  } 
 else {
    // GST is not present
    this.showGstSecondSlider = false;
    this.customerDetailsANDcarDetails = true;
  }
if (this.prefilledData?.gstDetails) {
  console.log('GST Address:', this.prefilledData.gstDetails.address);
  // Patch your form fields accordingly, e.g.:
  this.customerGstForm.patchValue({
    gstNumber: this.prefilledData.gstNumber || '',
    gstAddress: this.prefilledData.gstDetails.address || '',
    gstState: this.prefilledData.gstDetails.state || '',
    companyName: this.prefilledData.gstDetails.companyName || '',
    // ... other GST-related fields
  });
}

    // After you get prefilledData from API/parent, assign this.selectedRatecardType
    if (this.prefilledData?.rateCardApplicable) {
      this.selectedRatecardType = this.prefilledData.rateCardApplicable;
    }
  }
  console.log("selectedRatecardType", this.selectedRatecardType);
  
 this.fetchRateCardTypes();
}
  get f() { return this.vehicleForm1.controls; }
  onSubmit() {
    this.aspLoadingService.show();
    this.submitted = true;
    if (this.vehicleForm1.invalid) {
        return;
    }

    this.homeService.regDecode(this.f.regNo.value.replace(/\s/g, "")).subscribe(
      res => {
        if(res['code']==200){
          this.aspLoadingService.hide();
          this.vehicleInfo = true; 
          this.vehicleData = res['data'];
          console.log("vechileData",this.vehicleData);
          localStorage.setItem("vehicleData", JSON.stringify(this.vehicleData));  
          localStorage.setItem("registrationNumber",this.vehicleData.registrationNumber.replace(/"/g, ''));  

        }else{
          this.toastr.error(res['data']['description'], 'Error');          
          this.aspLoadingService.hide();
        }
      }
    );
  }

formatRegNo(value: string): string {
  value = value.replace(/\s+/g, '').toUpperCase();
  if (value.length > 2) {
      value = value.slice(0, 2) + ' ' + value.slice(2);
  }
  if (value.length > 5) {
      value = value.slice(0, 5) + ' ' + value.slice(5);
  }
  if (value.length >8){
    value = value.slice(0,8) + ' ' + value.slice(8);
  }
  return value;
}
  ngOnChanges(changes: SimpleChanges): void {
    if (changes.phoneNumber && changes.phoneNumber.currentValue) {
      this.vehicleForm1.patchValue({
        phoneNumber: changes.phoneNumber.currentValue
      });
    }
    if (changes.name && changes.name.currentValue) {
      this.vehicleForm1.patchValue({
        name: changes.name.currentValue
      });
    }
  }

 @HostListener('document:click', ['$event'])
  onClickOutside(event: MouseEvent) {
    const clickedInside = this.elementRef.nativeElement.contains(event.target);
    if (!clickedInside && this.isVisible) {
      this.closeSidebar(true);
      this.isVisible = true;
    }
  }
  closeAll(){
    this.closeSidebar(true);
    this.goBack();  
    this.isVisible = false;
    this.customerDetailsANDcarDetails=false;
  this.fuelAccessoriesContainer = false;
  this.gstDetails = false;
  this.showGstSecondSlider = false;
  this.showBusinessInfoSlider = false;
  this.showAddressSlider = false;
  }


  // onCreateJobCardClick(): void {
  //   this.isVisible = false;
  //   this.isSidebarOpen = true;
  // }


  onRegDecodeSubmit(): void {
    this.isManualSelection = false;
    this.formSubmitted = true;
    
    this.vehicleForm1.markAllAsTouched();
    if (this.vehicleForm1.valid) {
      this.aspLoadingService.show();
      // const regNo = this.vehicleForm1.get('regNo')?.value.toUpperCase().trim().replace(/\s+/g, ' ');
      const regNo = this.vehicleForm1.get('regNo')?.value.replace(/\s/g, '');
      console.log("reg no---", regNo);
      const odometer = this.vehicleForm1.get('odometer')?.value;
      const phoneNumber = this.vehicleForm1.get('phoneNumber')?.value;
      const name = this.vehicleForm1.get('name')?.value;
      const garageKey=localStorage.getItem("garageKey")
      console.log("garageKey")
      this.sideBarJobcardService.regDecode(regNo,garageKey).subscribe(
        (res: any) => {
          console.log("sidebarjobcard-response",res);
          this.aspLoadingService.hide();
          if ( res.data && res.code == 200 ) {
            this.jobCard = {
              make: res.data.make,
              registrationNumber: res.data.registrationNumber,
              model: res.data.model,
              variant: res.data.variant,
              mfgYear: res.data.year,
              fuelType: res.data.fuel,
              vin: res.data.vin,
              ExistingCustomer:res.data.isExistingCustomer
            };
            console.log("ExistingCustomer--",this.jobCard.ExistingCustomer);
            localStorage.setItem('selectedMake',res.data.make)
            localStorage.setItem('selectedModel',res.data.model)
            localStorage.setItem('selectedYear',res.data.year)
            localStorage.setItem('fuelType',res.data.fuel)
            localStorage.setItem('vin',res.data.vin) 
            localStorage.setItem('variant',res.data.variant)
            localStorage.setItem('registrationNumber',res.data.registrationNumber)
            this.vehicleForm1.patchValue({
              rowKey: res.data.rowKey,
              variantKey: res.data.variantKey,
            });
            const bookingId = res.data.bookingId;
            this.fetchPreFilledBooking(res.data.registrationNumber, bookingId);
            this.isVisible = false;
            this.isConfirmationSidebarOpen = true;
            this.jobCardDetails=true;
          } else {
              this.toastr.error('Car Details Not Found. Please Select Car Manually.');
              this.isConfirmationSidebarOpen = false;
            }
          },
        
        (error: any) => {
          console.error('Error:', error);
          this.aspLoadingService.hide();
        }
      );
    } else {
      this.vehicleForm1.markAllAsTouched();
    }
  }  

  closeSidebar(ishide: boolean): void {
    this.isVisible = ishide;
    this.isConfirmationSidebarOpen = false;
    if (localStorage.getItem('jobcard') && localStorage.getItem('jobcard') === '1') {
      localStorage.removeItem('jobcard');
      localStorage.removeItem('rowKey');
      localStorage.removeItem('selectedMake');
      localStorage.removeItem('selectedModel');
      localStorage.removeItem('selectedYear');
      localStorage.removeItem('variant');
      localStorage.removeItem('variantKey');
      localStorage.removeItem('fuelType');
      localStorage.removeItem('name');
      localStorage.removeItem('odometer');
      localStorage.removeItem('phoneNumber');
    }
  }

  toggleConfirmationSidebar(): void {
    this.isConfirmationSidebarOpen = !this.isConfirmationSidebarOpen;
    if (!this.isConfirmationSidebarOpen) {
      this.isVisible = true;
      this.ngOnInit();
    }
  }

  confirmCarDetails(param): void {
    this.aspLoadingService.show();    
    this.sideBarJobcardService.createbookingId(param).subscribe(
      (response: any) => {
        if (response && response.code === 200) {
          console.log("confirmdetails,response",response);
          this.aspLoadingService.hide();
          this.jobCardId = response.data.jobCardId;
          this.date = response.data.createdAt;
          this.isConfirmationSidebarOpen = false;
          this.isJobCardCreatedPopupVisible = true;
          this.clearLocalStorage();
        } else {
          this.aspLoadingService.hide();
          console.error('Unexpected response from API:', response);
        }
      },
      (error: any) => {
        this.aspLoadingService.hide();
        console.error('Error:', error);
        this.toastr.error('Failed to create booking due to a server error.');
        
      }
    );
  }

  clearLocalStorage(): void {
    localStorage.removeItem('jobcard');
    localStorage.removeItem('rowKey');
    localStorage.removeItem('selectedMake');
    localStorage.removeItem('selectedModel');
    localStorage.removeItem('selectedYear');
    localStorage.removeItem('variant');
    localStorage.removeItem('variantKey');
    localStorage.removeItem('fuelType');
    localStorage.removeItem('name');
    localStorage.removeItem('odometer');
    localStorage.removeItem('phoneNumber');
    if(localStorage.getItem("isFindMyCar")!='1'){
      localStorage.removeItem('selectedSparesList');
    }
    localStorage.removeItem('preSearchValue');
  };


  redirectToVehicleForm() {
    this.router.navigate(['vehicle']);
  
  }
  
  

  closeJobCardPopup() {
    this.isJobCardCreatedPopupVisible = false;
    this.ngOnInit();
    if(!this.isCustomerDetails){
      this.router.navigate(['my-job-cards']).then(() => {
        window.location.reload();
       });
    }
  }

  shareOnWhatsApp(): void {
    if (this.jobCard || this.jobCardId) {
      const message = `
        👋 Hello ${this.vehicleForm1.get('name')?.value || 'Customer'},
        🛠️ Your job card has been created successfully.
        📋 Job Card ID: ${this.jobCardId || 'N/A'}
        🚗 Odometer: ${this.vehicleForm1.get('odometer')?.value || 'N/A'}  
        📝 Registration Number: ${this.vehicleForm1.get('regNo')?.value || 'N/A'}
        🏷️ Make: ${this.jobCard.make || 'N/A'}
        🚙 Model: ${this.jobCard.model || 'N/A'}
        📅 Variant: ${this.jobCard.variant || 'N/A'}
        📆 MFG Year: ${this.jobCard.mfgYear || 'N/A'}
        ⛽ Fuel: ${this.jobCard.fuelType || 'N/A'}
        🔑 VIN: ${this.jobCard.vin || 'N/A'}
        We will soon send you a quotation for approval.
        Best regards, ${localStorage.getItem('spareSelectedGarageName') || 'Garage'}
      `;
      const url = `https://api.whatsapp.com/send?text=${encodeURIComponent(message)}`;
      window.open(url, '_blank');
    } else {
      alert('No booking data available to share.');
    }
  }


  // isManualSelectionValid(): boolean {
  //   const name = this.vehicleForm1.get('name')?.value;
  //   const phoneNumber = this.vehicleForm1.get('phoneNumber')?.value;
  //   const odometer = this.vehicleForm1.get('odometer')?.value;

  //   return !!(name && phoneNumber && odometer && phoneNumber.length === 10);
  // }

  redirectToManualSelection(): void {
    this.formSubmitted = true;
    this.vehicleForm1.markAllAsTouched();
    // if (this.isManualSelectionValid()) {

      localStorage.setItem('name', this.vehicleForm1.get('name')?.value);
      localStorage.setItem('phoneNumber', this.vehicleForm1.get('phoneNumber')?.value);
      // localStorage.setItem('odometer', this.vehicleForm1.get('odometer')?.value);
      localStorage.setItem('jobcard', '1');
      this.router.navigate(['/make']);
      this.isConfirmationSidebarOpen = true;
      localStorage.removeItem('vin');
      localStorage.removeItem('vinNumber');
    // } 
    // else{
    //   this.vehicleForm1.markAllAsTouched(); 
    //   // }
  }
  openCarDetailsSidebar(): void {
    this.isSideSliderOpen = true; // Set the slider to open
    console.log('Side slider opened');
    // this.closeAllSidebars();
    this.jobCardDetails = false;

    
  }

confirmDetails() {
  // this.jobCardDetails = false; 
  if (this.prefilledData?.gstNumber && this.prefilledData.gstNumber.trim() !== '' && this.hasGst) {
    this.isConfirmationSidebarOpen = false;
    this.isVisible = true;
    this.showGstSecondSlider = true;

  } else {
    this.customerDetailsANDcarDetails = true;
     this.jobCardDetails = false;
     this.isConfirmationSidebarOpen = false;
     this.isVisible = true;
    // this.customerDetailsANDcarDetails = true;
    // this.gstDetails = false;
    // this.showGstSecondSlider = false;
  }

  localStorage.removeItem('jobcard');
}

  // Navigate to Fuel and Accessories section
  goToAccessories(): void {
    window.scrollTo({ top: 0, behavior: 'smooth' });
    this.carDetailsandcustomerDetails = false;
    this.jobCardDetails = false; 
    this.fuelAccessoriesContainer = true;
    this.fetchAccessories();
  }

  // Navigate to Issues section
  goToIssuesSection(): void {
    window.scrollTo({ top: 0, behavior: 'smooth' });
    this.jobCardDetails = false; 
    this.carDetailsandcustomerDetails = false;
    this.fuelAccessoriesContainer = false;
    this.issuesSection = true;
    this.fetchServices();
    this.scrollToTop();
  }
  // Navigate to Exterior section
  goToExteriorSection(): void {
    window.scrollTo({ top: 0, behavior: 'smooth' });
    this.jobCardDetails = false; 
    this.carDetailsandcustomerDetails = false;
    this.fuelAccessoriesContainer = false;
    this.issuesSection = false;
    this.exteriorSection = true;
  }
  // Navigate to Image section
  goToImageSection(): void {
    window.scrollTo({ top: 0, behavior: 'smooth' });
    this.jobCardDetails = false; 
    this.carDetailsandcustomerDetails = false;
    this.fuelAccessoriesContainer = false;
    this.issuesSection = false;
    this.exteriorSection = false;
    this.imageSection = true;
  }

  // back to the previous sidebar 
  goBack(): void {
    if (this.imageSection) {
      this.imageSection = false; // Turn off the current section
      this.exteriorSection = true; // Activate the next section
    } else if (this.exteriorSection) {
      this.exteriorSection = false;
      this.issuesSection = true;
    } else if (this.issuesSection) {
      this.issuesSection = false;
      this.fuelAccessoriesContainer = true;
    } else if (this.fuelAccessoriesContainer) {
      this.fuelAccessoriesContainer = false;
      this.carDetailsandcustomerDetails = true;
    } else if (this.customerDetailsANDcarDetails) {
      this.customerDetailsANDcarDetails = false;
      this.jobCardDetails = true;
    } else {
      console.warn("No section is currently active to switch from.");
    }
  }

  // back to the previous sidebar. end----------------------------------


  // --------------------------DROPDOWN IN SERVICE TYPE SECTION--------------------------
  toggleDropdown(): void {
    this.isDropdownOpen = !this.isDropdownOpen;
      
      // Fetch services when dropdown is opened
      if (this.isDropdownOpen) {
        this.fetchServices(); // Call the API to fetch services
      }
  }

  // Fetch service list from the backend
  fetchServices(): void {
    this.sideBarJobcardService.getServiceList().subscribe(
      (response) => {
        if (response.code === 200) {
          this.data=response.data;
          console.log("data",this.data)
          // Populate service list with response data
          this.serviceList = response.data.serviceTypes; // Assuming response has a 'serviceTypes' field
          // console.log('Fetched Service List:', this.serviceList);
        } else {
          // console.error('Error fetching service list:', response.message);
        }
      },
      (error) => {
        console.error('API Error:', error);
      }
    );
    this.fetchAccessories();
    this.fetchIssues();
  }


  // Select or deselect a service
  // selectService(service: string, event: any): void {
  //   if (event.target.checked) {
  //     this.selectedServices.push(service); // Add service to selected list
  //   } else {
  //     const index = this.selectedServices.indexOf(service);
  //     if (index > -1) {
  //       this.selectedServices.splice(index, 1); // Remove service from selected list
  //     }
  //   }
  // }

  selectService(service: string, event: Event) {
    const checkbox = event.target as HTMLInputElement;
    if (checkbox.checked) {
      if (!this.car.selectedServices.includes(service)) {
        this.car.selectedServices.push(service);
      }
    } else {
      this.car.selectedServices =
        this.car.selectedServices.filter((s) => s !== service);
    }
  }

  // saveDetails() {
  //   const car = this.car;
  //   const customer = this.customer;

  //   this.errorMessage = '';

  //   // Validation flags
  //   let isValid = true;
  //   // Check if required car fields are filled
  //   if (!car.odometerReading || car.selectedServices.length === 0) {
  //     // this.errorMessage = 'Please fill mandatory fields';
  //     return;
  //   }

  //   // Check if required customer fields are filled
  //   if (!customer.name || !customer.mobile) {
  //     this.errorMessage = 'Please fill mandatory fields: Name and Mobile.';
  //     return;
  //   }

  //   // Check if phone number is valid (10 digits only)
  //   const phonePattern = /^[0-9]{10}$/;
  //   if (!customer.mobile || customer.mobile.length < 10) {
  //     this.errorMessage = 'Should be a minimum of 10 digits.';
  //     return;
  //   }
    
  //   if (!phonePattern.test(customer.mobile)) {
  //     this.errorMessage = 'Please enter a valid phone number (10 digits).';
  //     return;
  //   }

  //   // Check if the name contains only letters
  //   const namePattern = /^[a-zA-Z\s]+$/;
  //   if (customer.name && !namePattern.test(customer.name)) {
  //     this.errorMessage = 'Please enter a valid name (letters only).';
  //     return;
  //   }

  //   // Check if odometer reading contains only numbers
  //   const odometerPattern = /^[0-9]+$/;
  //   if (car.odometerReading && !odometerPattern.test(car.odometerReading)) {
  //     this.errorMessage = 'Please enter a valid odometer reading (numbers only).';
  //     return;
  //   }

  //   // Clear the error message if all validations pass
  //   this.errorMessage = '';

  //   // Proceed if all validations pass
  //   console.log('Saved details:', this.carandcustomerDetails);
  //   this.carDetailsandcustomerDetails = false;
  //   this.goToAccessories();
  // }

  saveDetails() {
    const car = this.car;
    const customer = this.customer;

    this.errorMessage = '';

    // Helper function to scroll to a specific element
    const scrollToField = (elementId: string) => {
        setTimeout(() => {
            const element = document.getElementById(elementId);
            if (element) {
                element.scrollIntoView({ behavior: 'smooth', block: 'center' });
                (element as HTMLElement).focus();
            }
        }, 100);
    };

    // Check if name is empty and scroll
    // if (!customer.name) {
    //     this.errorMessage = 'Please fill mandatory fields: Name and Mobile.';
    //     scrollToField('customerNameInput'); // Scroll to name field
    //     return;
    // }

    // Check if phone number is empty and scroll
    // if (!customer.mobile) {
    //     this.errorMessage = 'Please fill mandatory fields: Name and Mobile.';
    //     scrollToField('customerMobileInput'); // Scroll to phone number field
    //     return;
    // }

    // Check if service type is empty and scroll
    if (!car.selectedServices || car.selectedServices.length === 0) {
        this.errorMessage = 'Please select a service type.';
        scrollToField('serviceTypeInput'); // Scroll to service type dropdown
        return;
    }

    // Validation flags
    let isValid = true;

    // Check if phone number is valid (10 digits only)
    const phonePattern = /^[0-9]{10}$/;
    if (!customer.mobile || customer.mobile.length < 10) {
        this.errorMessage1 = 'Should be a minimum of 10 digits.';
        scrollToField('ratecardTypeInput');
        return;
    }else{
      this.errorMessage1 = '';
    }

    if (!phonePattern.test(customer.mobile)) {
        this.errorMessage2 = 'Please enter a valid phone number (10 digits).';
        return;
    }else{
      this.errorMessage2 = '';
    }

    // Check if the name contains only letters
    const namePattern = /^[a-zA-Z\s]+$/;
    if (customer.name && !namePattern.test(customer.name)) {
        this.errorMessage3 = 'Please enter a valid name (letters only).';
        return;
    }

    // Check if odometer reading contains only numbers
    const odometerPattern = /^[0-9]+$/;
    if (car.odometerReading && !odometerPattern.test(car.odometerReading)) {
        this.errorMessage4 = 'Please enter a valid odometer reading (numbers only).';
        return;
    }
      console.log("customer.ratecardType",customer.ratecardType)
    if(this.selectedRatecardType){
      customer.ratecardType=this.selectedRatecardType;
    }
    console.log("customer.ratecardType",customer.ratecardType)
      if (!customer.ratecardType) {
        this.errorMessage5 = 'Please select a Ratecard Type.';
        scrollToField('ratecardTypeInput'); // Ensure the ID is added in template
        return;
    }

    // Clear the error message if all validations pass
    this.errorMessage = '';
this.errorMessage1 = '';
this.errorMessage2 = '';
this.errorMessage3 = '';
this.errorMessage4 = '';
this.errorMessage5 = '';
    // Proceed if all validations pass
    console.log('Saved details:', this.carandcustomerDetails);
    this.carDetailsandcustomerDetails = false;
    this.goToAccessories();
    this.scrollToTop();

}

scrollToTop() {
  if (this.scrollContainer) {
    this.scrollContainer.nativeElement.scrollTo({ top: 0, behavior: 'smooth' });
  } else {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }
}

    // Remove a service from the selected services list
  removeService(service: string) {
    console.log('Selected services:', this.car.selectedServices); // Log the full array
    console.log('Service to remove:', service); // Log the specific service to be removed
    const index = this.car.selectedServices.indexOf(service);
    if (index > -1) {
      this.car.selectedServices.splice(index, 1);
    } else {
      console.log('Service not found in array');
    }
  }
// ----pendil color change-----------


  toggleDrawing(): void {
    this.isDrawing = !this.isDrawing; 
    if (this.isDrawing) {
      this.selectedColor = 'red'; 
    } else {
      this.selectedColor = 'black'; 
    }
  }

  // --------------------------DROPDOWN IN SERVICE TYPE SECTION ENDS HERE--------------------------

  // ---------------Update fuel level--------------
  updateFuelLevel(event: any): void {
    this.fuelAndAccessories.fuelLevel = event;
    console.log('Fuel Level:', this.fuelAndAccessories.fuelLevel);
  }

  // Fetch accessories data from API
  fetchAccessories(): void {
    this.sideBarJobcardService.getServiceList().subscribe(
      (response) => {
        // console.log('Fetched Accessories response:', response);
        if (response.code === 200) {
          this.accessories = response.data.accessories || [];       
          // console.log('Fetched Accessories:', this.accessories);
        } else {
          console.error('Error fetching accessories:', response.message);
        }
      },
      (error) => {
        console.error('API Error:', error);
      }
    );
  }


  // ---------------------Add or remove accessories----------------------
  selectAccessory(accessory: string, event: any): void {
    if (event.target.checked) {
      this.fuelAndAccessories.checkedItems.push(accessory);
    } else {
      const index = this.fuelAndAccessories.checkedItems.indexOf(accessory);
      if (index > -1) {
        this.fuelAndAccessories.checkedItems.splice(index, 1);
      }
    }
    console.log('Fuel and Accessories:', this.fuelAndAccessories);
  }
  // -----------------------selection tabs to mark damaged images ---------------------------
  // selectTab(tab: string) {
  //   this.selectedTab = tab;

  //   // Clear the canvas for the new tab
  //   const canvas = this.drawingCanvas.nativeElement;
  //   if (this.canvasContext) {
  //     this.canvasContext.clearRect(0, 0, canvas.width, canvas.height);
  //   }

  //   // Optionally restore previous drawings if needed (not specified in the requirement)
  // }

  selectTab(tab: string) {
    // Save the marked image before switching tabs
    this.saveMarkedImage();

    // Switch to the selected tab
    this.selectedTab = tab;
    this.scrollToElement(this.carImageContainer);


    // Scroll to the top of the car-image-container
    setTimeout(() => {
      if (this.carImageContainer) {
        console.log('Scrolling to car-image-container'); 
        this.carImageContainer.nativeElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
      } else {
        console.log('car-image-container not found'); 
      }
    }, 100);

    // Clear and resize the canvas
    setTimeout(() => {
      const canvas = this.drawingCanvas.nativeElement;
      const image = document.querySelector('.image-canvas-container img') as HTMLImageElement;
      if (image) {
        canvas.width = image.clientWidth;
        canvas.height = image.clientHeight;
      }
      if (canvas.getContext) {
        const context = canvas.getContext('2d');
        if (context) {
          context.clearRect(0, 0, canvas.width, canvas.height);
        }
      }
    }, 200);

    // Restore the saved image for the selected tab
    setTimeout(() => this.restoreMarkedImage(), 300);
  }
restoreMarkedImage() {
  const canvas = this.drawingCanvas.nativeElement;
  const context = canvas.getContext('2d');
  const savedImageData = this.damagedImagesData[this.selectedTab];
  
  if (savedImageData && context) {
    const img = new Image();
    img.onload = () => {
      // Clear canvas and redraw saved annotations
      context.clearRect(0, 0, canvas.width, canvas.height);
      context.drawImage(img, 0, 0, canvas.width, canvas.height);
    };
    img.src = savedImageData;
  }
}


  // -----------------------selection tabs to mark damaged images. END---------------------------

  // Method to open the hidden calendar
  openCalendar(): void {
    // Ensure the calendar input exists and is triggered
    const calendarInput = document.getElementById('calendar') as HTMLInputElement;
    if (calendarInput) {
      calendarInput.click();  // Open the calendar by simulating a click
    }
  }

  // Method to set the date when the calendar changes
  setDate(event: Event): void {
    const calendarInput = event.target as HTMLInputElement;
    const selectedDate = calendarInput.value;
    const dateInput = document.getElementById('last-service-date') as HTMLInputElement;

    // Set the selected date to the last-service-date text input
    if (dateInput && selectedDate) {
      dateInput.value = selectedDate;
    }
  }

  // -------------------------------ENABLING DRAWING----------------

  enableDrawing() {
    const canvas = this.drawingCanvas.nativeElement;
    const image = document.querySelector('.image-canvas-container img') as HTMLImageElement;
  
    if (!image) return; // Ensure an image exists
  
    // Match canvas size to image
    canvas.width = image.clientWidth;
    canvas.height = image.clientHeight;
    canvas.style.position = 'absolute';
    canvas.style.top = '0';
    canvas.style.left = '0';
    canvas.style.cursor = 'crosshair'; // Set pointer while marking
  
    canvas.style.pointerEvents = 'auto'; // Enable drawing
    this.canvasContext = canvas.getContext('2d')!;
    if (this.canvasContext) {
      this.canvasContext.strokeStyle = 'red';
      this.canvasContext.lineWidth = 2;
    }
  }
 
  // startDrawing(event: MouseEvent): void {
  //   this.isImageModified = true;
  //   const canvas = this.drawingCanvas.nativeElement;
  //   const rect = canvas.getBoundingClientRect();
  
  //   if (this.canvasContext) {
  //     const x = event.clientX - rect.left;
  //     const y = event.clientY - rect.top;
  
  //     this.canvasContext.beginPath();
  //     this.canvasContext.moveTo(x, y);
  //     this.isDrawing = true;
  //     this.currentPath = [{ x, y }]; // Start new path
  
  //     canvas.style.cursor = 'crosshair'; // Keep pointer while marking
  //   }
  // }
  
  // stopDrawing(): void {
  //   if (this.canvasContext) {
  //     this.canvasContext.closePath();
  //   }
  //   this.isDrawing = false;
  
  //   const canvas = this.drawingCanvas.nativeElement;
  //   canvas.style.cursor = 'default'; // Reset cursor when not drawing
  
  //   if (this.currentPath.length > 0) {
  //     this.drawingHistory.push(this.currentPath);
  //   } else {
  //     this.damagedImagesData[this.selectedTab] = null; // No drawing for this tab
  //   }
  // }
  
  //   draw(event: MouseEvent): void {
  //     if (!this.isDrawing || !this.canvasContext) return;
    
  //     const canvas = this.drawingCanvas.nativeElement;
  //     const rect = canvas.getBoundingClientRect();
  //     const x = event.clientX - rect.left;
  //     const y = event.clientY - rect.top;
    
  //     this.canvasContext.lineTo(x, y);
  //     this.canvasContext.stroke();
  //     this.currentPath.push({ x, y });
  //   }
  
  //   getDamagedTabs(): string[] {
  //     return Object.keys(this.damagedImagesData).filter(tab => this.damagedImagesData[tab]);
  //   }
  //   undoDrawing() {
  //     if (this.drawingHistory.length > 0) {
  //       this.drawingHistory.pop(); 
  //       this.redrawCanvas(); 
  //     } 
  //   }
  //    // Redraw the canvas with all previous paths
  //    redrawCanvas() {
  //     const canvas = this.drawingCanvas.nativeElement;
  //     if (this.canvasContext) {
  //       this.canvasContext.clearRect(0, 0, canvas.width, canvas.height); // Clear the entire canvas
  //     }
  //   }

    startDrawing(event: MouseEvent | TouchEvent): void {
      this.isImageModified = true;
      const canvas = this.drawingCanvas.nativeElement;
      const rect = canvas.getBoundingClientRect();
    
      let x, y;
      if (event instanceof TouchEvent) {
        const touch = event.touches[0];
        x = touch.clientX - rect.left;
        y = touch.clientY - rect.top;
      } else {
        x = (event as MouseEvent).clientX - rect.left;
        y = (event as MouseEvent).clientY - rect.top;
      }
    
      if (this.canvasContext) {
        this.canvasContext.strokeStyle = 'red';   // <-- Add this
        this.canvasContext.lineWidth = 2;  
        this.canvasContext.beginPath();
        this.canvasContext.moveTo(x, y);
        this.isDrawing = true;
        this.currentPath = [{ x, y }];
        canvas.style.cursor = 'crosshair';
      }
    
      event.preventDefault(); // Prevent scrolling on touch
    }
    
    draw(event: MouseEvent | TouchEvent): void {
      if (!this.isDrawing || !this.canvasContext) return;
    
      const canvas = this.drawingCanvas.nativeElement;
      const rect = canvas.getBoundingClientRect();
    
      let x, y;
      if (event instanceof TouchEvent) {
        const touch = event.touches[0];
        x = touch.clientX - rect.left;
        y = touch.clientY - rect.top;
      } else {
        x = (event as MouseEvent).clientX - rect.left;
        y = (event as MouseEvent).clientY - rect.top;
      }
      
      this.canvasContext.strokeStyle = 'red';   // <-- Add this
      this.canvasContext.lineWidth = 2; 
      this.canvasContext.lineTo(x, y);
      this.canvasContext.stroke();
      this.currentPath.push({ x, y });
    
      event.preventDefault(); // Prevent scrolling on touch
    }
    
    stopDrawing(): void {
      if (this.canvasContext) {
        this.canvasContext.closePath();
      }
      this.isDrawing = false;
    
      const canvas = this.drawingCanvas.nativeElement;
      canvas.style.cursor = 'default';
    
      if (this.currentPath.length > 0) {
        this.drawingHistory.push(this.currentPath);
      } else {
        this.damagedImagesData[this.selectedTab] = null;
      }
    }
  
    
    saveMarkedImage() {
      if (!this.isImageModified) {
        console.log(`No changes made to ${this.selectedTab}, skipping save.`);
        return; // Do not save if the image was not marked
      }
      const canvas: HTMLCanvasElement | null = document.querySelector('.drawing-canvas');
      const image: HTMLImageElement | null = document.querySelector('.image-canvas-container img');
    
      if (!canvas || !image) {
        console.error('Canvas or Image element is not available.');
        return;
      }
    
      const tempCanvas = document.createElement('canvas');
      const context = tempCanvas.getContext('2d');
    
      if (!context) {
        console.error('Failed to get temporary canvas context.');
        return;
      }
    
      tempCanvas.width = image.width;
      tempCanvas.height = image.height;
    
      // Combine the image and annotations
      context.drawImage(image, 0, 0, image.width, image.height);
      context.drawImage(canvas, 0, 0, canvas.width, canvas.height);
    
      // Convert the combined canvas to a Base64 string
      const markedImageData = tempCanvas.toDataURL('image/png');
    
      // Save the marked image data for the selected tab
      // console.log("markedImageData",markedImageData)
      // console.log("damagedImagesData",this.damagedImagesData)
      this.damagedImagesData[this.selectedTab] = markedImageData;
    
      this.isImageSaved = true;
    
      // console.log(`Marked image saved for ${this.selectedTab}:`, markedImageData);
    }
    
    activateDrawing(event: MouseEvent): void {
      if (!this.isDrawing) {
        this.enableDrawing(); // Activates the pencil mode
      }
      this.startDrawing(event); // Starts the drawing process
    }


  // ----SEARCH CHECKBOX----

  fetchIssues(): void {
    this.sideBarJobcardService.getServiceList().subscribe(
      (response) => {
        if (response.code === 200) {
          this.issuesData = response.data.symptoms || [];
          this.filteredIssues = this.issuesData;     
        } else {
          console.error('Error fetching issues:', response.message);
        }
      },
      (error) => {
        console.error('API Error:', error);
      }
    );
  }

  toggleSearch() {
    this.isSearchOpen = !this.isSearchOpen;
    this.isSearchSidebarOpen = !this.isSearchSidebarOpen;

  }

  // Toggle issue selection
  toggleIssue(issue: string, event: Event) {
    // console.log('Selected issue:', issue);  // Debugging line
    const checkbox = event.target as HTMLInputElement;
    if (checkbox.checked) {
      this.selectedIssues.push(issue);  // Add to selectedIssues
    } else {
      this.selectedIssues = this.selectedIssues.filter(i => i !== issue);  // Remove from selectedIssues
    }
  }


  saveIssue(): void {
    // Store the selected issues into issuesData (or any other required variable)
    this.issuesData = [...this.selectedIssues];
    this.goToExteriorSection();
    this.scrollToTop();
  }

  // Remove selected issue
  removeIssue(issueToRemove: string): void {
    const index = this.selectedIssues.indexOf(issueToRemove);
    if (index > -1) {
      this.selectedIssues.splice(index, 1);
    }
  }

  // selectIssues(service: string, event: any): void {
  //   if (event.target.checked) {
  //     this.selectedIssues.push(service); // Add service to selected list
  //   } else {
  //     const index = this.selectedIssues.indexOf(service);
  //     if (index > -1) {
  //       this.selectedIssues.splice(index, 1); // Remove service from selected list
  //     }
  //   }
  // }
  
  // ------------------SEARCH SUGGESTION------------
  filterIssues() {
    // console.log('Search text:', this.searchText);  // Debug searchText
    if (!this.searchText || this.searchText.length < 3) {
      // console.log('No filtering applied. Returning all issues.');
      this.filteredIssues = this.issuesData;  // No filtering if search text is less than 3
    } else {
      const query = this.searchText.toLowerCase();
      // console.log('Filtering issues with query:', query);  // Debug query

      this.filteredIssues = this.issuesData.filter(issue => {
        // Ensure the issue description is not undefined or null
        const description = issue ? issue.toLowerCase() : '';
        return description.includes(query);  // Filter based on description field
      });

      // console.log('Filtered Issues:', this.filteredIssues);  // Log filtered issues
    }
  }


  highlightMatch(text: string, search: string): string {
    if (!search) return text;

    const regex = new RegExp(`(${search})`, 'gi');
    return text.replace(regex, match => `<span class="highlight">${match}</span>`);
  }

  // highlightMatch(text: string): string {
  //   const query = this.searchQuery.toLowerCase();
  //   const matchIndex = text.toLowerCase().indexOf(query);
  //   if (matchIndex !== -1) {
  //     const beforeMatch = text.slice(0, matchIndex);
  //     const match = text.slice(matchIndex, matchIndex + query.length);
  //     const afterMatch = text.slice(matchIndex + query.length);
  //     return `${beforeMatch}<strong>${match}</strong>${afterMatch}`;
  //   }
  //   return text;
  // }


  // -----CLEAR SEARCH---------------
  clearSearch() {
    this.searchText = '';  // Reset search text
    this.filteredIssues = this.issuesData;
    // Add any other logic to reset filters if needed
  }

  // Trigger file input click programmatically
  triggerFileInput(section: string): void {
    this.selectedSection = section;

    // Map the section to the corresponding file input
    const fileInputMap: { [key: string]: ElementRef<HTMLInputElement> } = {
      front: this.frontFileInput,
      engine: this.engineFileInput,
      battery: this.batteryFileInput,
      right: this.rightFileInput,
      back: this.backFileInput,
      left: this.leftFileInput,
      add: this.addFileInput,
      'Fuel-Level': this.fuelFileInput, // Added Fuel Level
      'fuel-meter-image': this.meterFileInput,
      'accessorry-images':this.accessoryFileInput
    };

    const fileInput = fileInputMap[section];
    if (fileInput) {
      fileInput.nativeElement.click();
    } else {
      console.error('File input not found for section:', section);
    }
  }



  // Handle image selection
  onImageSelected(section: string, event: Event): void {
    const input = event.target as HTMLInputElement;
    if (input.files && input.files.length > 0) {
      const file = input.files[0];
      this.previewImage(file, section);

      // Save the uploaded image in the respective section variable
      const reader = new FileReader();
      reader.onload = (e: any) => {
        switch (section) {
          case 'front':
            this.frontImage = e.target.result;
            break;
          case 'engine':
            this.engineImage = e.target.result;
            break;
          case 'battery':
            this.batteryImage = e.target.result;
            break;
          case 'right':
            this.rightImage = e.target.result;
            break;
          case 'back':
            this.backImage = e.target.result;
            break;
          case 'left':
            this.leftImage = e.target.result;
            break;
          case 'fuel': 
            this.fuelLevelImage = e.target.result;
            break;
          case 'add':
            this.addImage = e.target.result;
            break;
          default:
            break;
        }
        console.log(`${section} image uploaded and saved to variable:`, e.target.result);
      };
      reader.readAsDataURL(file); // Read the file as a data URL (base64 encoded)
    } else {
      // console.error('No file selected');
    }
  }


  previewImage(file: File, section: string): void {
    const reader = new FileReader();
    reader.onload = (e: any) => {
      this.selectedImages[section] = e.target.result;
      this.uploadedImages[section] = e.target.result;
      this.uploadedImages[section] = e.target.result;
    };
    reader.readAsDataURL(file); // Read file content
  }
  // Simulated image upload function
  uploadImage(file: File): void {
    const formData = new FormData();
    formData.append('image', file);
    formData.append('section', this.selectedSection);

    // console.log('Uploading image...', formData);
  }
  
  // createJobCard() {
  //   this.isConfirmationSidebarOpen = false;
  //   this.isVisible = false;
  //   this.customerDetailsANDcarDetails=false;
  //   this.fuelAccessoriesContainer = false;
    
  //   // local starage data
  //   this.garageKey = localStorage.getItem('garageKey');
  //   const userId = localStorage.getItem('spareUserKey');
  //   const rowKey = localStorage.getItem('rowKey')||this.vehicleForm1.get('rowKey')?.value;
  //   const variantKey = localStorage.getItem('variantKey')||this.vehicleForm1.get('variantKey')?.value;

  //   //Formated form data
  //   this.FinalJobcardDetails = {};    
  //   this.FinalJobcardDetails['damagedImagesS3'] = [];
  //   this.FinalJobcardDetails['imagesS3'] = [];
  //   console.log("cardetails",this.car);
  //   this.FinalJobcardDetails['car'] = this.car;
  //   this.FinalJobcardDetails['vehicleinfo'] = this.jobCard;
  //   this.FinalJobcardDetails['customer'] = this.customer;
  //   this.FinalJobcardDetails['accessories'] = this.fuelAndAccessories?.checkedItems;
  //   this.FinalJobcardDetails['fuelLevel'] = this.fuelAndAccessories?.fuelLevel;
  //   this.FinalJobcardDetails['issues'] = this.issuesData;
  //   this.FinalJobcardDetails['damagedImages'] = this.damagedImagesData;
  //   this.FinalJobcardDetails['images'] = {
  //     front: this.frontImage || null,
  //     engine: this.engineImage || null,
  //     battery: this.batteryImage || null,
  //     right: this.rightImage || null,
  //     back: this.backImage || null,
  //     left: this.leftImage || null,
  //     add: this.addImage || null,
  //   };

  //   const input = event.target as HTMLInputElement;

  //   // Damaged Images
  //   if (
  //     this.FinalJobcardDetails['damagedImages']?.Front?.length > 0 || 
  //     this.FinalJobcardDetails['damagedImages']?.Top?.length > 0 || 
  //     this.FinalJobcardDetails['damagedImages']?.Right?.length > 0 || 
  //     this.FinalJobcardDetails['damagedImages']?.Left?.length > 0 || 
  //     this.FinalJobcardDetails['damagedImages']?.Rear?.length > 0
  //   ) {
      
  //     Object.entries(this.FinalJobcardDetails['damagedImages']).forEach(([key, damagedImage]) => {
          
  //         if(damagedImage != null && damagedImage !=undefined){
  //           let timestamp =  Math.floor(Date.now() / 1000);
  //           let fileName = timestamp+"_"+key.toLowerCase()+'.png';

  //           this.s3ImageUploadService.getPresignedUrl(fileName).subscribe({
  //             next: (response) => {
  //               // console.log("getPresignedUrl",response)
  //               const presignedUrl = response[0]?.signedUrl;
  //               const link = response[0]?.link;
      
  //               if (presignedUrl || link) {
  //                 this.uploadFileToS3(presignedUrl, damagedImage); 
  //                 // this.FinalJobcardDetails['damagedImagesS3'].push({"url": link, "tag": key.toLowerCase()});
  //                 this.FinalJobcardDetails['damagedImagesS3'].push({
  //                   "url": link,
  //                   "tag": `damage_${key.toLowerCase()}`
  //               });
                
  //               } else {
  //                 console.error('Invalid presigned URL or link:', response);
  //                 this.aspLoadingService.hide();
  //               }
                
  //             },
  //             error: (err) => {
  //               console.error('Error fetching presigned URL:', err);
  //             },
  //           });
  //         };
  //     } )
  //   }
   
  //   // Images
  //   if (
  //     this.FinalJobcardDetails['images']?.front?.length > 0 || 
  //     this.FinalJobcardDetails['images']?.engine?.length > 0 || 
  //     this.FinalJobcardDetails['images']?.battery?.length > 0 || 
  //     this.FinalJobcardDetails['images']?.right?.length > 0 || 
  //     this.FinalJobcardDetails['images']?.back?.length > 0 || 
  //     this.FinalJobcardDetails['images']?.left?.length > 0 || 
  //     this.FinalJobcardDetails['images']?.add?.length > 0
  //   ) {
      
  //     Object.entries(this.FinalJobcardDetails['images']).forEach(([key, images]) => {
          
  //         if(images != null && images !=undefined){
  //           let timestamp =  Math.floor(Date.now() / 1000);
  //           let fileName = timestamp+"_"+key.toLowerCase()+'.png';

  //           this.s3ImageUploadService.getPresignedUrl(fileName).subscribe({
  //             next: (response) => {
  //               const presignedUrl = response[0]?.signedUrl;
  //               const link = response[0]?.link;
      
  //               if (presignedUrl || link) {
  //                 this.uploadFileToS3(presignedUrl, images); 
  //                 this.FinalJobcardDetails['imagesS3'].push({"url": link, "tag": key.toLowerCase()});
  //               } else {
  //                 console.error('Invalid presigned URL or link:', response);
  //                 this.aspLoadingService.hide();
  //               }
                
  //             },
  //             error: (err) => {
  //               console.error('Error fetching presigned URL:', err);
  //             },
  //           });
  //         }
  //     });
  //   }

  //   setTimeout(() => {  
  //     let regNo:any;
  //     if(this.FinalJobcardDetails.vehicleinfo.registrationNumber) {
  //       regNo = this.FinalJobcardDetails.vehicleinfo.registrationNumber;
  //     } else{
  //       regNo = this.FinalJobcardDetails.car.regNumber;
  //     }
      
  //     let param = {
  //       "name": this.FinalJobcardDetails.customer.name,
  //       "phoneNumber": this.FinalJobcardDetails.customer.mobile,
  //       "odometer": this.FinalJobcardDetails.car.odometerReading,
  //       "registrationNumber": regNo,
  //       "engineNumber": this.FinalJobcardDetails.car.engineNumber,
  //       "lastServiceDate": this.FinalJobcardDetails.car.lastServiceDate,
  //       "userKey": userId,
  //       "checkDetails": [
  //         {
  //           "type": "service type",
  //           "services": this.FinalJobcardDetails.car.selectedServices
  //         },
  //         {
  //           "type": "accessories",
  //           "services": this.FinalJobcardDetails.accessories
  //         },
  //         {
  //           "type": "issues",
  //           "services": this.FinalJobcardDetails.issues
  //         }
  //       ],

  //       "damageImages": this.FinalJobcardDetails['damagedImagesS3'],
  //       "images": this.FinalJobcardDetails['imagesS3'],
  //       "fuelLevel": this.FinalJobcardDetails.fuelLevel,
  //       "rowKey": rowKey,
  //       "variantKey": variantKey,
  //       "garageKey": this.garageKey,
  //       "email": this.FinalJobcardDetails.customer.email,
  //       "fuelPercent": this.FinalJobcardDetails.fuelLevel,
  //       "vinNumber": this.FinalJobcardDetails.vehicleinfo.vin,
  //       "year":this.FinalJobcardDetails.vehicleinfo.mfgYear,
  //       "bookingId": 0
  //     };

  //     // console.log("Data",this.FinalJobcardDetails);
  //     // console.log("Data String",JSON.stringify(this.FinalJobcardDetails));
  //     // console.log("Data",param);
  //     // console.log("Data String",JSON.stringify(param));
      
  //     this.confirmCarDetails(param);
  //   }, 3000); 
  // } 
  createJobCard() {
    this.aspLoadingService.show(); 
    this.isConfirmationSidebarOpen = false;
    this.isVisible = false;
    this.customerDetailsANDcarDetails = false;
    this.fuelAccessoriesContainer = false;

    // Local Storage Data
    this.garageKey = localStorage.getItem('garageKey');
    const userId = localStorage.getItem('spareUserKey');
    const rowKey = localStorage.getItem('rowKey') || this.vehicleForm1.get('rowKey')?.value;
    const variantKey = localStorage.getItem('variantKey') || this.vehicleForm1.get('variantKey')?.value;

    // Formatted Form Data
    this.FinalJobcardDetails = {};    
    this.FinalJobcardDetails['damagedImagesS3'] = [];
    this.FinalJobcardDetails['imagesS3'] = [];
    this.FinalJobcardDetails['car'] = this.car;
    this.FinalJobcardDetails['vehicleinfo'] = this.jobCard;
    this.FinalJobcardDetails['customer'] = this.customer;
    this.FinalJobcardDetails['accessories'] = this.fuelAndAccessories?.checkedItems;
    this.FinalJobcardDetails['fuelLevel'] = this.fuelAndAccessories?.fuelLevel;
    this.FinalJobcardDetails['issues'] = this.issuesData;
    this.FinalJobcardDetails['damagedImages'] = this.damagedImagesData;
    this.FinalJobcardDetails['images'] = {
      front: this.frontImage || null,
      engine: this.engineImage || null,
      battery: this.batteryImage || null,
      right: this.rightImage || null,
      back: this.backImage || null,
      left: this.leftImage || null,
      add: this.addImage || null,
      'Fuel-Level': this.fuelLevelImage || null,
     };

    if (this.fuelMeterImagePreview.length > 0){
      this.fuelMeterImage = this.fuelMeterImagePreview.map((image) => ({
        url: image,
        tag: "fuel_meter"
      }));
    }
     this.FinalJobcardDetails['fuelMeterImage'] = this.fuelMeterImage || null;
     if (this.accessoriesImagesPreview.length > 0) {
      this.accessoriesImages = this.accessoriesImagesPreview.map((image, index) => ({
        url: image,
        tag: `accessories_${index + 1}`
      }));
    }
    
     this.FinalJobcardDetails['accessoriesImages'] = this.accessoriesImages || null;

     if (Array.isArray(this.newImages)) {
      this.newImages.forEach(imageObj => {
        if (imageObj.key) {
          this.FinalJobcardDetails['images'][imageObj.key] = imageObj.image || null;
        }
      });
    }
    console.log("this.newImages['key']",this.newImages)
    console.log("this.FinalJobcardDetails['images']",this.FinalJobcardDetails['images'])
    // console.log("Damaged Images Data:", this.FinalJobcardDetails['damagedImages']);
    // console.log("Regular Images Data:", this.FinalJobcardDetails['images']);

    // Handle Damaged Images Upload
    if (this.FinalJobcardDetails['damagedImages']) {
        Object.entries(this.FinalJobcardDetails['damagedImages']).forEach(([key, damagedImage]) => {
            if (damagedImage) {
                this.aspLoadingService.show(); 
                let timestamp = Math.floor(Date.now() / 1000);
                let fileName = `${timestamp}_damage_${key.toLowerCase()}.png`;

                this.s3ImageUploadService.getPresignedUrl(fileName).subscribe({
                    next: (response) => {
                        // console.log("Pre-signed URL Response:", response);
                        const presignedUrl = response[0]?.signedUrl;
                        const link = response[0]?.link;

                        if (presignedUrl && link) {
                            this.uploadFileToS3(presignedUrl, damagedImage);
                            this.FinalJobcardDetails['damagedImagesS3'].push({
                                "url": link,
                                "tag": `damage_${key.toLowerCase()}`
                            });
                        } else {
                            console.error('Invalid presigned URL or link:', response);
                        }
                    },
                    error: (err) => {
                        console.error('Error fetching presigned URL:', err);
                    }
                });
            }
        });
    }

    // Handle Regular Images Upload
    if (this.FinalJobcardDetails['images']) {
      console.log("this.FinalJobcardDetails['images']",this.FinalJobcardDetails['images'])
        Object.entries(this.FinalJobcardDetails['images']).forEach(([key, image]) => {
            if (image) {
              this.aspLoadingService.show(); 

                let timestamp = Math.floor(Date.now() / 1000);
                let fileName = `${timestamp}_${key.toLowerCase()}.png`;

                this.s3ImageUploadService.getPresignedUrl(fileName).subscribe({
                    next: (response) => {
                        // console.log("Pre-signed URL Response:", response);
                        const presignedUrl = response[0]?.signedUrl;
                        const link = response[0]?.link;

                        if (presignedUrl && link) {
                            this.uploadFileToS3(presignedUrl, image);
                            this.FinalJobcardDetails['imagesS3'].push({
                                "url": link,
                                "tag": key.toLowerCase()
                            });
                        } 
                         // Specifically store the fuel meter image URL
                        //  if (key.toLowerCase() === 'fuel-meter-image') {
                        //   this.FinalJobcardDetails['fuelMeterImage'] = link;
                        // }
                        if (key.toLowerCase() === 'fuel-meter-image') {
                          this.FinalJobcardDetails['fuelMeterImage'] = [
                            {
                              "url": link,
                              "tag": "fuel_meter"
                            }
                          ];
                        }
                        
                        if (key.toLowerCase() === 'accessorry-images') {
                          if (!this.FinalJobcardDetails['accessoriesImages']) {
                            this.FinalJobcardDetails['accessoriesImages'] = [];
                          }
                          
                          let imageIndex = this.FinalJobcardDetails['accessoriesImages'].length + 1;
                        
                          this.FinalJobcardDetails['accessoriesImages'].push({
                            "url": link,
                            "tag": `accessories_${imageIndex}`
                          });
                        }
                        
                        else {
                            console.error('Invalid presigned URL or link:', response);
                        }
                    },
                    error: (err) => {
                        console.error('Error fetching presigned URL:', err);
                    }
                });
            }
        });
    }

    if (this.FinalJobcardDetails['fuelMeterImage']) {
      this.aspLoadingService.show(); 
      let timestamp = Math.floor(Date.now() / 1000);
      let fileName = `${timestamp}_fuel_meter.png`;
    
      this.s3ImageUploadService.getPresignedUrl(fileName).subscribe({
          next: (response) => {
              const presignedUrl = response[0]?.signedUrl;
              const link = response[0]?.link;
    
              if (presignedUrl && link) {
                  this.uploadFileToS3(presignedUrl, this.FinalJobcardDetails['fuelMeterImage'][0]?.url);
                  this.FinalJobcardDetails['fuelMeterImageS3'] = [
                    {
                      "url": link,
                      "tag": "fuel_meter"
                    }
                  ];
              } else {
                  console.error('Invalid presigned URL or link:', response);
              }
          },
          error: (err) => {
              console.error('Error fetching presigned URL:', err);
          }
      });
    }
    
    if (this.FinalJobcardDetails['accessoriesImages'] && this.FinalJobcardDetails['accessoriesImages'].length > 0) {
      this.FinalJobcardDetails['accessoriesImagesS3'] = []; // Initialize array for S3 links
      this.aspLoadingService.show(); 
      this.FinalJobcardDetails['accessoriesImages'].forEach((imageObj, index) => {
        let timestamp = Math.floor(Date.now() / 1000);
        let fileName = `${timestamp}_accessory_${index + 1}.png`;
    
        this.s3ImageUploadService.getPresignedUrl(fileName).subscribe({
          next: (response) => {
            const presignedUrl = response[0]?.signedUrl;
            const link = response[0]?.link;
    
            if (presignedUrl && link) {
              this.uploadFileToS3(presignedUrl, imageObj.url);
              this.FinalJobcardDetails['accessoriesImagesS3'].push({
                "url": link,
                "tag": imageObj.tag
              });
            } else {
              console.error("Invalid presigned URL or link:", response);
            }
          },
          error: (err) => {
            console.error("Error fetching presigned URL:", err);
          }
        });
      });
    }

    const gstDetails = {
      gstNumber: this.cgf.gstNumber.value || null,
      addressLine1: this.af.addressLine1.value || null,
      addressLine2: this.af.addressLine2.value || null,
      city: this.af.city.value || null,
      pincode: this.af.pincode.value || null,
      state: this.cgf.state.value || null,
      companyName: this.cgf.businessName.value || null,
    };
    
    const isGstDetailsEmpty = Object.values(gstDetails).every(value => value === null);
    
    const customerGstDetails = isGstDetailsEmpty ? null : {
      ...gstDetails,
      address: `${gstDetails.addressLine1 || ''}, ${gstDetails.addressLine2 || ''}, ${gstDetails.city || ''} - ${gstDetails.pincode || ''}`,
    };
    

    // if (customerGstDetails['gstNumber'] == null || customerGstDetails['gstNumber'] == '' ){alert("customerGstDetails = null")
    //   customerGstDetails : null
    // }
    // else{alert("customerGstDetails !=null")
    //   customerGstDetails : customerGstDetails
    // }
    
    // Wait for Uploads & Proceed to Next Step
    setTimeout(() => {
        let regNo: any = this.FinalJobcardDetails.vehicleinfo.registrationNumber || this.FinalJobcardDetails.car.regNumber;
        
        // Convert lastServiceDate to "YYYY-MM-DD 00:00:00" format
        let lastServiceDate = null;

        if (this.FinalJobcardDetails.car.lastServiceDate) {
          let selectedDate = new Date(this.FinalJobcardDetails.car.lastServiceDate);
      
          // Extract local date parts
          let year = selectedDate.getFullYear();
          let month = String(selectedDate.getMonth() + 1).padStart(2, '0');
          let day = String(selectedDate.getDate()).padStart(2, '0');
      
          lastServiceDate = `${year}-${month}-${day} 00:00:00`;
        }
        
      
       

        let param = {
            "name": this.FinalJobcardDetails.customer.name,
            "phoneNumber": this.FinalJobcardDetails.customer.mobile,
            "rateCardApplicable": this.FinalJobcardDetails.customer.ratecardType || 'default',
            "odometer": this.FinalJobcardDetails.car.odometerReading,
            "registrationNumber": regNo,
            "engineNumber": this.FinalJobcardDetails.car.engineNumber,
            // "lastServiceDate": this.FinalJobcardDetails.car.lastServiceDate,
            "lastServiceDate": lastServiceDate, 
            "userKey": userId,
            "checkDetails": [
          {
            "type": "service type",
            "services": this.FinalJobcardDetails.car.selectedServices
          },
          {
            "type": "accessories",
            "services": this.FinalJobcardDetails.accessories
          },
          {
            "type": "issues",
            "services": this.FinalJobcardDetails.issues
          }
        ],
            "damageImages": this.FinalJobcardDetails['damagedImagesS3'],
            "images": this.FinalJobcardDetails['imagesS3'],
            "fuelLevel": this.FinalJobcardDetails.fuelLevel,
            "rowKey": rowKey,
            "variantKey": variantKey,
            "garageKey": this.garageKey,
            "email": this.FinalJobcardDetails.customer.email,
            "fuelPercent": this.FinalJobcardDetails.fuelLevel,
            "vinNumber": this.FinalJobcardDetails.vehicleinfo.vin,
            "year": this.FinalJobcardDetails.vehicleinfo.mfgYear,
            "fuelMeterImage": this.FinalJobcardDetails['fuelMeterImageS3'],  // Ensure this is correctly assigned
            "accessoriesImages": this.FinalJobcardDetails['accessoriesImagesS3'],  // Ensure this is correctly assigned

            "bookingId": this.bookingId,
            "customerGstDetails": customerGstDetails
            
        };

        console.log("Final Job Card Data:", param);
        this.confirmCarDetails(param);
    }, 3000);
}

  // Upload file to S3
  uploadFileToS3(presignedUrl,file): void {  
    // console.log('Presigned URL:', presignedUrl);
    // const contentType = file.type;
    const blobData = this.base64ToBlob(file);

    const contentType = 'image/png';
    this.http.put(presignedUrl, blobData, {
      headers: { 'Content-Type': contentType },
    }).subscribe({
      next: () => {
        console.log('File uploaded successfully.');
      },
      error: (err) => {
        console.error('Error uploading file:', err);
      },
      complete: () => {
        this.aspLoadingService.hide();
      },
    });
  }

  private base64ToBlob(base64: string): Blob {
    // Ensure Base64 prefix is removed if present
    const base64Data = base64.split(',')[1];
    const byteCharacters = atob(base64Data);
    const byteArrays = [];
  
    for (let offset = 0; offset < byteCharacters.length; offset += 512) {
      const slice = byteCharacters.slice(offset, offset + 512);
      const byteNumbers = new Array(slice.length).fill(0).map((_, i) => slice.charCodeAt(i));
      const byteArray = new Uint8Array(byteNumbers);
      byteArrays.push(byteArray);
    }
  
    return new Blob(byteArrays, { type: 'image/png' });
  }

  getMakeImageUrl(make: string): string {
    const makeWithoutSpaces = make.toLowerCase().replace(/\s+/g, '');
    return `https://cube.getpitstop.com/assets/img/${makeWithoutSpaces}.png`;
  }

  // ----PREFILLED-----------
  // fetchPreFilledBooking(registrationNumber, bookingId: string): void {
  //   // const registrationNumber = "registrationNumber";
  //   const garageKey = localStorage.getItem('garageKey');
  //   this.sideBarJobcardService.getPreFilledBooking(registrationNumber, garageKey, this.bookingId).subscribe(
  //     res => {
  //       console.log("bookingid", this.bookingId);
  //       console.log('Fetched pre-filled booking data:', res);
  //       if (res && res.data) {
  //         this.customer.name = res.data.name;
  //         this.customer.mobile = res.data.mobile;
  //         this.customer.email = res.data.email;
  //         this.car.vin = res.data.vin;
  //         this.car.engineNumber = res.data.engineNumber;
  //         this.showServiceHistory = true; // Show the button if response exists
  //         this.isExistingCustomer=res.data.existingCustomer;
  //         console.log("this.isExistingCustomer----",this.isExistingCustomer);
  //       } else {
  //         this.showServiceHistory = false; // Hide the button if no response data
  //       }
  //     },
  //     error => {
  //       console.error('Error fetching booking data:', error);
  //       this.showServiceHistory = false;
  //     }
  //   );
  // }
  fetchPreFilledBooking(registrationNumber: string, bookingId: string): void {
  // Check if opened from customer
  const jobcardFrom = localStorage.getItem('jobcardFrom');

  if (jobcardFrom === 'customer' && this.prefilledData) {
    // Use prefilledData instead of API call
    console.log('Using prefilled data from customer:', this.prefilledData);

    this.customer.name = this.prefilledData.customerName || '';
    this.customer.mobile = this.prefilledData.mobile || '';
    this.customer.email = this.prefilledData.email || '';
    this.car.vin = this.prefilledData.vinNumber || '';
    this.car.engineNumber = this.prefilledData.engineNumber || '';
    this.showServiceHistory = true;
    this.isExistingCustomer = false; // or set accordingly

  } else {
    // Check if opened from Job Card
    const garageKey = localStorage.getItem('garageKey');
    this.sideBarJobcardService.getPreFilledBooking(registrationNumber, garageKey, bookingId).subscribe(
      res => {
        console.log("bookingid", bookingId);
        console.log('Fetched pre-filled booking data:', res);
        if (res && res.data) {
          this.customer.name = res.data.name;
          this.customer.mobile = res.data.mobile;
          this.customer.email = res.data.email;
          this.car.vin = res.data.vin;
          this.car.engineNumber = res.data.engineNumber;
          this.showServiceHistory = true;
          this.isExistingCustomer = res.data.existingCustomer;
          console.log("this.isExistingCustomer----", this.isExistingCustomer);
        } else {
          this.showServiceHistory = false;
        }
      },
      error => {
        console.error('Error fetching booking data:', error);
        this.showServiceHistory = false;
      }
    );
  }
}


  openBottomSheet(section: string): void {
    this.selectedSection = section;
    this.isBottomSheetOpen = true;  
  
    // Trigger the file input click if the section is 'add'
    // if (section === 'add' && this.addFileInput) {
    //   this.addFileInput.nativeElement.click();
    // }
  }

  
  onFileSelected(event: Event, section: string): void {
    const input = event.target as HTMLInputElement;
    if (input.files && input.files.length > 0) {
      const file = input.files[0];
      const reader = new FileReader();
  
      reader.onload = () => {
        if (section === 'add') {
          this.addImage = reader.result as string;
          this.isBottomSheetOpen = false; 
        }
      };
  
      reader.readAsDataURL(file);
    }
  }
  
  
  // Close the bottom sheet
  closeBottomSheet(): void {
    this.isBottomSheetOpen = false; 
  }
  
  // Save the tag and trigger the file input
  saveTag(): void {
    if (!this.otherImageFile || !this.otherTag) {
      console.error('Image or tag not provided');
      return;
    }
  
    const reader = new FileReader();
    reader.onload = (e: any) => {
      const newImage = { image: e.target.result, key: this.otherTag };
  
      // ✅ Ensure arrays are initialized before pushing
      if (!Array.isArray(this.otherImages)) {
        this.otherImages = [];
      }
      this.otherImages.push(newImage);

      if (this.otherImages.length > 0) {
        const addedImgDiv = document.getElementById('added-img1');
        if (addedImgDiv) {
          addedImgDiv.style.display = 'contents';
        }
      }
  
      if (!Array.isArray(this.newImages)) {
        this.newImages = [];
      }
      this.newImages.push(newImage);
  
      console.log("✅ Updated otherImages:", this.otherImages);
      console.log("✅ Updated newImages:", this.newImages);
  
      // ✅ Update UI without duplicating elements
      const addedImgDiv = document.getElementById('added-img1');
      let otherImagesDiv = document.getElementById('otherimages');
  
      if (!otherImagesDiv) {
        otherImagesDiv = document.createElement('div');
        otherImagesDiv.id = 'otherimages';
        otherImagesDiv.style.display = 'contents';
        addedImgDiv?.appendChild(otherImagesDiv);
      }
  
      const imageBox = document.createElement('div');
      imageBox.className = 'image-box';
  
      const imgElement = document.createElement('img');
      imgElement.src = newImage.image;
      imgElement.alt = newImage.key;
      imgElement.className = 'latest-image'; 
  
      const spanElement = document.createElement('span');
      spanElement.className = 'image-gridtext'; 
      spanElement.textContent = newImage.key;
  
      imageBox.appendChild(imgElement);
      imageBox.appendChild(spanElement);
      otherImagesDiv.appendChild(imageBox);
  
      // ✅ Reset inputs
      this.otherTag = '';
      this.otherImageFile = null;
    };
  
    reader.readAsDataURL(this.otherImageFile);
    this.isBottomSheetOpen = false;
  }
  
  
  onOtherImageSelected(event: Event): void {
    const input = event.target as HTMLInputElement;
    if (input.files && input.files.length > 0) {
      this.otherImageFile = input.files[0];
    }
  }
//   goToNextTab() { 
//     // Save the marked image for the current tab
//     this.saveMarkedImage();

//     // Clear the canvas for the current tab
//     const canvas: HTMLCanvasElement | null = document.querySelector('.drawing-canvas');
//     if (canvas) {
//         const context = canvas.getContext('2d');
//         if (context) {
//             context.clearRect(0, 0, canvas.width, canvas.height);
//         }
//     }

//     // Determine the next tab
//     const tabs = ['Front', 'Rear', 'Right', 'Left', 'Top'];
//     const currentIndex = tabs.indexOf(this.selectedTab);

//     if (currentIndex < tabs.length - 1) {
//         // Move to the next tab
//         this.selectedTab = tabs[currentIndex + 1];
//         this.isImageModified = false; // Reset modification state

//         setTimeout(() => {
//           const nextButton = document.querySelector('.create-order-btn') as HTMLElement;
//           if (nextButton) {
//               console.log('Scrolling to NEXT button'); // Debug log
//               nextButton.scrollIntoView({ behavior: 'smooth', block: 'start' });
//           } else {
//               console.log('NEXT button not found'); // Debug log
//           }
//       }, 100); // Ensure DOM updates before scrolling

//         // Restore the marked image for the new tab
//         // setTimeout(() => this.restoreMarkedImage(), 100); // Slight delay to ensure tab update
//     } else {
//         // All tabs completed, navigate to the image section
//         this.goToImageSection();
//     }
//     this.scrollToTop();
// }
goToNextTab() {
  // Save the marked image for the current tab
  this.saveMarkedImage();

  // Clear the canvas for the current tab
  setTimeout(() => {
    const canvas = this.drawingCanvas.nativeElement;
    if (canvas.getContext) {
      const context = canvas.getContext('2d');
      if (context) {
        context.clearRect(0, 0, canvas.width, canvas.height);
      }
    }
  }, 100);

  // Determine the next tab
  const tabs = ['Front', 'Rear', 'Right', 'Left', 'Top'];
  const currentIndex = tabs.indexOf(this.selectedTab);

  if (currentIndex < tabs.length - 1) {
    // Move to the next tab
    this.selectedTab = tabs[currentIndex + 1];
    this.isImageModified = false; // Reset modification state

    // Scroll to the top of car-image-container
    setTimeout(() => {
      if (this.carImageContainer) {
        console.log('Scrolling to car-image-container'); 
        this.carImageContainer.nativeElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
      } else {
        console.log('car-image-container not found'); 
      }
    }, 200);

    // Scroll to the NEXT button
    setTimeout(() => {
      if (this.nextButton) {
        console.log('Scrolling to NEXT button'); 
        this.nextButton.nativeElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
      } else {
        console.log('NEXT button not found'); 
      }
    }, 300);

    // Restore the marked image for the new tab
    setTimeout(() => this.restoreMarkedImage(), 400);
  } else {
    // All tabs completed, navigate to the image section
    this.goToImageSection();
  }
}
scrollToElement(element: ElementRef) {
  if (element?.nativeElement) {
    element.nativeElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
  } else {
    console.log('Element not found:', element);
  }
}
  
  get rf() {
    return this.carDetailsForm.controls;
  }
  onChangeCarClick(): void {
    // this.carDetailsandcustomerDetails = false;
    this.customerDetailsANDcarDetails = false;
    // this.fuelAccessoriesContainer = false;
    // this.issuesSection = false;
    // this.exteriorSection = false;
    // this.imageSection = false;
    // this.jobCardDetails = false; 
    this.isVisible = true;  
    this.ngOnInit();
}

openServiceHistory(): void {
  // Dynamically create the component
  const factory = this.resolver.resolveComponentFactory(AspVehicleServiceHistoryComponent);
  const componentRef = this.historyContainer.createComponent(factory);

  // Access the instance and call the closeSidebar or similar method
  const serviceHistoryInstance = componentRef.instance as AspVehicleServiceHistoryComponent;
  serviceHistoryInstance.openSidebar(true);
  // this.carDetailsandcustomerDetails = false;
  //   this.customerDetailsANDcarDetails = false;
  //   this.fuelAccessoriesContainer = false;
  //   this.issuesSection = false;
  //   this.exteriorSection = false;
  //   this.imageSection = false;
  //   this.jobCardDetails = false; 
  //   this.isVisible = false; 
}

addSelectedIssue(issue: string) {
  if (!this.selectedIssues.includes(issue)) {
    this.selectedIssues.push(issue);
  }
}
navigateToDetails(jobCardId,bookingId) {
  bookingId = bookingId ? bookingId : 0;
  
  // console.log("jobcard-id, boooking-id", jobCardId, bookingId)
  this.router.navigate(['/my-job-cards-details', jobCardId, bookingId]);
  }
onResize() {
  const viewportHeight = window.innerHeight;
  const documentHeight = document.documentElement.clientHeight;

  if (viewportHeight < documentHeight) {
    // Keyboard is likely open, move the button up
    this.nextButton.nativeElement.style.position = 'absolute';
    this.nextButton.nativeElement.style.bottom = '50px'; // Adjust as needed
  } else {
    // Keyboard is closed, reset position
    this.nextButton.nativeElement.style.position = 'sticky';
    this.nextButton.nativeElement.style.bottom = this.originalBottom;
  }
}
onFuelImageUpload(event: any): void {
  const file = event.target.files[0];
  if (file) {
    const reader = new FileReader();
    reader.onload = (e: any) => {
      this.fuelAndAccessories.fuelLevel = e.target.result; // Store Base64 image
    };
    reader.readAsDataURL(file);
  }
}
handleFileUpload(event: Event, type: string): void {
  const file = (event.target as HTMLInputElement).files?.[0];
  if (file) {
    const reader = new FileReader();
    reader.onload = () => {
      if (type === 'fuel') {
        this.fuelLevelImage = reader.result as string;
      }
    };
    reader.readAsDataURL(file);
  }
}

  // Adding other symptoms apart from list
  addTag() {
    if (this.searchText.trim()) {
      this.selectedIssues.push(this.searchText.trim());
      this.clearSearch();
    }
  }

  onFuelImageSelected(event: any): void {
    console.log("Fuel Image Selection Triggered", event);
    console.log("evebt target",event.target.files);

    if (event.target.files && event.target.files.length > 0) {
      this.fuelMeterImage = []; // Clear previous selections
      this.fuelMeterImagePreview = []; // Clear previous previews
  console.log("event target of image accessories",event.target.files)
      for (let file of event.target.files) {
        const reader = new FileReader();
        reader.onload = (e: any) => {
          this.fuelMeterImagePreview.push(e.target.result,); // Store multiple images
          this.fuelMeterImage.push(e.target.result);
          // ,{"tags":"selected1"}
        // this.tagsValue = this.fuelMeterImage[1].tags;
        //   console.log(this.tagsValue);  // Outputs: "selected1"

          console.log("image accessories---",this.fuelMeterImage); // Store base64 data for uploading
        };
        reader.readAsDataURL(file);
      }
      if (this.FinalJobcardDetails['fuelMeterImage']) {
        // Ensure fuelMeterImagePreview is populated with objects
        this.fuelMeterImagePreview = this.FinalJobcardDetails['fuelMeterImage'].map(item => ({
          url: item.url, 
          tag: item.tag || 'Fuel Level'  // Default to 'Fuel Level' if no tag is present
        }));
        console.log("fuelMeterImagePreview", this.fuelMeterImagePreview);
      }
    }
  }

//   onFuelImageSelected(event: any): void {
//     console.log("Fuel Image Selection Triggered", event);
//     const file0 = event.target.files[0];
//     const file = event.target.files;

//     console.log("file0--",file0);

//     if (!file) {
//         console.error("No file selected.");
//         return;
//     }
//     console.log("Selected File:", file);
//     const reader = new FileReader();
//     reader.onload = (e: any) => {
//         console.log("File Read Success:", e.target.result);
//         this.fuelMeterImagePreview = e.target.files;
//         this.fuelMeterImage = e.target.files; 
//         console.log("meghana images----", this.fuelMeterImage);
//         if (!this.FinalJobcardDetails['images']) {
//             this.FinalJobcardDetails['images'] = {};
//         }
//         this.FinalJobcardDetails['images']['fuel-meter-image'] = this.fuelMeterImage;
//     };
//     reader.onerror = (error) => {
//         console.error("File Read Error:", error);
//     };
//     reader.readAsDataURL(file);
// }

removeFuelImage() {
    this.fuelMeterImagePreview = null; // Remove the fuel image
    this.fuelMeterImage = null;

    // Update FinalJobcardDetails
    if (this.FinalJobcardDetails['images']) {
        this.FinalJobcardDetails['images']['fuel-meter-image'] = null;
    }
}


// onAccessoriesImagesSelected(event: any): void {
//   if (event.target.files && event.target.files.length > 0) {
//     this.accessoriesImages = []; // Clear previous selections
//     this.accessoriesImagesPreview = []; // Clear previous previews
// console.log("event target of image accessories",event.target.files)
//     for (let file of event.target.files) {
//       const reader = new FileReader();
//       reader.onload = (e: any) => {
//         this.accessoriesImagesPreview.push(e.target.result); // Store multiple images
//         this.accessoriesImages.push(e.target.result);
//         console.log("image accessories---",this.accessoriesImages); // Store base64 data for uploading
//       };
//       reader.readAsDataURL(file);
//     }
//   }
// }

onAccessoriesImagesSelected(event: any): void {
  if (event.target.files && event.target.files.length > 0) {
    this.accessoriesImages = []; // Clear previous selections
        this.accessoriesImagesPreview = []; // Clear previous previews
    console.log("event target of image accessories", event.target.files);

    for (let file of event.target.files) {
      const reader = new FileReader();
      reader.onload = (e: any) => {
        this.accessoriesImagesPreview = [...this.accessoriesImagesPreview, e.target.result]; // Append new images
        this.accessoriesImages = [...this.accessoriesImages, e.target.result]; // Store base64 data for uploading
        console.log("image accessories---", this.accessoriesImages);
      };
      reader.readAsDataURL(file);
    }
  }
}


removeAccessoryImage(index: number) {
  this.accessoriesImagesPreview.splice(index, 1);
}
// ==================GST 1ST-SIDEBAR-CODE===============

closeGstSlider() {
  this.gstDetails = false;      
  this.jobCardDetails = true;   
}

skipForNow() {
  this.gstDetails = false;  
  this.showGstSecondSlider = false;
  this.customerDetailsANDcarDetails = true; 
}

selectGstOption(isGstAvailable: boolean) {
  this.hasGst = isGstAvailable;  // ✅ Fix: Directly use parameter
}

continueNextStep() {
  if (this.hasGst !== null) {
      this.gstDetails = false;
      this.customerDetailsANDcarDetails = true;
  }
  if (this.hasGst) {
        this.showGstSecondSlider = true;
            this.ngOnInit();
        if(localStorage.getItem("jobcardFrom")){
            this.gstNumber = this.prefilledData.gstNumber
            console.log("this.gstnumber----",this.gstNumber)
          }  // Show second slider
      }




  
}
closeGstDetails(){
  this.gstDetails = false
}

// ================= GST-2ND SLIDER============
 // Function to validate GST input

// Function to show the second slider when "Yes" is selected
// continueNextStep() {
//   if (this.hasGst) {
//     this.showGstSecondSlider = true;  // Show second slider
//   }
// }

// Close Second Slider
closeSecondSlider() {
  this.showGstSecondSlider = false;
  this.gstDetails = true;
}

// Proceed to Next Step
proceedToNextStep(): void {
  if (this.gstNumber.length === 15) {
    this.customerGstForm.patchValue({ gstNumber: this.gstNumber });
    this.openBusinessSlider();
  }
}



openBusinessSlider() {
  this.showBusinessInfoSlider = true;
  this.showGstSecondSlider = false;
  // console.log("this.gsrNumbert----" ,this.cgf.get('gstNumber').value);
  console.log("gstnumber==---,",this.customerGstForm.get('gstNumber').value);
  
  this.fetchGstPrefilledDetails(this.customerGstForm.get('gstNumber').value);
}

closeBusinessSlider() {
  this.showBusinessInfoSlider = false;
  this.showGstSecondSlider = true;
}


// validateGstInput() {
//   if (this.gstNumber.length > 15) {
//       this.gstNumber = this.gstNumber.substring(0, 15);
//       console.log("gstNumber---",this.gstNumber);
//   }
// }
validateGstInput() {
  const control = this.customerGstForm.get('gstNumber');
  const value = control?.value?.toUpperCase() || '';
  control?.setValue(value, { emitEvent: false });
  if (this.gstNumber.length > 15) {
    this.gstNumber = this.gstNumber.substring(0, 15);
    console.log("gstNumber---",this.gstNumber);
}
}

// ==============end business -slider-gst=======

// ===================image-viewer====================
closeViewer(): void {
  this.isViewerOpen = false;
}
closeViewerAccessories(): void {
  this.isAccessoriesViewerOpen = false;
}
openViewerAccessories(index: number) {
  this.isAccessoriesViewerOpen = true;
  this.meterImageUrl = this.accessoriesImages;
  console.log("this.meterImage---",this.meterImageUrl);
  this.currentIndex = index;
  this.selectedImage = this.meterImageUrl[this.currentIndex];
  console.log("this.selectedImage----",this.selectedImage);
  
}

openViewer(index: number) {
  this.isViewerOpen = true;
  this.meterImageUrl = this.fuelMeterImagePreview;
  console.log("this.meterImage---",this.meterImageUrl);
  this.currentIndex = index;
  this.selectedImage = this.meterImageUrl;
  console.log("this.selectedImage----",this.selectedImage);
  
}
prevImage1() {
  if (this.currentIndex > 0) {
    this.currentIndex--;
    this.selectedImage = this.accessoriesImages[this.currentIndex];
    console.log("selectedimage-----",this.selectedImage)
  }
}

nextImage1() {
  if (this.currentIndex < this.accessoriesImages.length - 1) {
    this.currentIndex++;
    this.selectedImage = this.accessoriesImages[this.currentIndex];
    console.log("selectedimagnext-----",this.selectedImage)
    }
  }

// =========stats-selection======
openStateSlider(): void {
  this.stateSliderOpen = true;
  this.fetchStates();
}

closeStateSlider(): void {
  this.stateSliderOpen = false;
}

fetchStates(): void {
  this.sideBarJobcardService.getStateList().subscribe(
    (response) => {
      if (response.code === 200) {
        this.stateData = response.data;
        this.filteredStates = [...this.stateData]; // Ensure filteredStates has full objects
      } else {
        console.warn('Error fetching states:', response.message);
      }
    },
    (error) => {
      console.error('API Error while fetching states:', error);
    }
  );
}

// fetchGstPrefilledDetails(gstNumber: string): void {
//   this.sideBarJobcardService.getPreFilledGstDetails(this.customerGstForm.get('gstNumber').value).subscribe(
//     (response : any) => {
//       if (response.code === 200 && response.data && typeof response.data === 'object') {
//         this.gstDetails = response.data;
//         this.buisnessname = this.gstDetails['companyName'];
//         this.state = this.gstDetails['state'];
//         this.addressLine1 = this.gstDetails['addressLine1']
//         this.addressLine2 = this.gstDetails['addressLine2']
//         this.city = this.gstDetails['city']
//         this.pincode = this.addressForm['pincode']
//         console.log("company name----",this.buisnessname);
//         console.log("addressLine1----",this.addressLine1);
//         console.log("addressLine2----",this.addressLine2);
//         console.log("city----",this.city);
//         console.log("pincode----",this.pincode);
//         console.log('Fetched GST Pre-filled Details:', this.gstDetails);
//         this.customerGstForm.patchValue({
//           businessName: this.buisnessname || '',
//           gstNumber: gstNumber,
//           state: this.buisnessname || ''
//         });

//         this.addressForm.patchValue({
//           addressLine1: addressLine1 || '',
//           addressLine2: addressLine2 || '',
//           city: city || '',
//           pincode: pincode || ''
//         });

//         this.selectedState = this.cgf.state.value || '';
//       } else {
//         console.warn('No pre-filled data found for this GST number:', response.message);
//       }
//     },
//     (error) => {
//       console.error('API Error while fetching GST pre-filled details:', error);
//     }
//   );
// }

fetchGstPrefilledDetails(gstNumber: string): void {
  this.sideBarJobcardService.getPreFilledGstDetails(gstNumber).subscribe(
    (response: any) => {
      if (response.code === 200 && response.data && typeof response.data === 'object') {
        const gstData = response.data;

        console.log("Fetched GST Details", gstData);
        console.log("-------state",gstData.state )

        // ✅ Patch the form with direct values from the response
        this.addressForm.patchValue({
          addressLine1: gstData.addressLine1 || '',
          addressLine2: gstData.addressLine2 || '',
          city: gstData.city || '',
          pincode: gstData.pincode || ''
        });

        console.log("Patching form with:", {
          addressLine1: gstData.addressLine1,
          addressLine2: gstData.addressLine2,
          city: gstData.city,
          pincode: gstData.pincode
        });
        

        this.selectedState = gstData.state || '';
        this.customerGstForm.patchValue({
          businessName: gstData.companyName || '',
          // gstNumber: gstNumber,
          state: gstData.state || ''
        });
        console.log("this.state for prefilled gst--",this.selectedState);
      } else {
        console.warn('No pre-filled data found for this GST number:', response.message);
      }
    },
    (error) => {
      console.error('API Error while fetching GST pre-filled details:', error);
    }
  );
}



filterStates(): void {
  if (!this.searchTextStates) {
    this.filteredStates = [...this.stateData];
  } else {
    this.filteredStates = this.stateData.filter(state =>
      state.name.toLowerCase().includes(this.searchTextStates.toLowerCase())
    );
  }
}
clearStateSearch(): void {
  this.searchTextStates = '';
  this.filteredStates = [...this.stateData];
}

selectState(state: any): void {
  this.selectedState = state.name; // just the name as string
  console.log("Selected state ----", this.selectedState);

  this.customerGstForm.patchValue({ state: this.selectedState });
  this.stateSliderOpen = false;

  console.log("Form value after patch ----", this.customerGstForm.value);
}



// ===============gst address slide-sidre==================
openAddressSlider() {
  if (this.customerGstForm.get('businessName')?.invalid || this.customerGstForm.get('state')?.invalid) {
    this.customerGstForm.get('businessName')?.markAsTouched();
    this.customerGstForm.get('state')?.markAsTouched();
    return;
  }

  // Proceed if valid
  console.log("Proceeding to address slider...");
  this.showAddressSlider = true;
  this.showBusinessInfoSlider = false;
  this.customerDetailsANDcarDetails = false;

}

// Close Address Slider
closeAddressSlider() {
  this.showAddressSlider = false;
  this.showBusinessInfoSlider = true;
}

saveAddressDetails() {
  if (this.addressForm.valid) {
    const addressDetails = this.addressForm.value;

    this.showAddressSlider = false;
    this.customerDetailsANDcarDetails = true;
    this.jobCardDetails = false;

    console.log('✅ Address saved:', addressDetails);
  } else {
    console.warn('❌ Address form is invalid:', this.addressForm.errors);
    this.addressForm.markAllAsTouched();
  }
}

onRatecardDropdownOpened(opened: boolean): void {
  if (opened && this.ratecardTypes.length === 0) {
    this.fetchRateCardTypes();
  }
}

 fetchRateCardTypes(): void {
    const garageKey = localStorage.getItem('garageKey');
    if (!garageKey) {
      console.warn('Garage key not found in local storage.');
      return;
    }

    this.sideBarJobcardService.getRateCardByGarageKey(garageKey).subscribe(
      (response) => {
        
          console.log("response",response)
        if (response.code === 200) {
          this.ratecardTypes = response.data.rateCardTypes;
          // If prefilledData is already there, set the selectedRatecardType here to ensure dropdown has values
          if (this.prefilledData?.rateCardApplicable) {
            // Check if prefilled rateCardApplicable exists in the fetched list, else set empty
            if (this.ratecardTypes.includes(this.prefilledData.rateCardApplicable)) {
              this.selectedRatecardType = this.prefilledData.rateCardApplicable;
            } else {
              this.selectedRatecardType = '';
            }
          }
        } else {
          console.warn('Error fetching rate card types:', response.message);
        }
      },
      (error) => {
        console.error('API Error while fetching rate card types:', error);
      }
    );
  }
}